import { AgentThreadStatus as ThreadStatus } from "@ui/agent/components/agent/api/chat-api";

export { ThreadStatus };

export type ThreadStatusLabelKey =
  | "threadStatusInProgress"
  | "threadStatusError"
  | "threadStatusReady"
  | "threadStatusInputRequired"
  | "threadStatusCompleted"
  | "threadStatusCancelled";

export const THREAD_STATUS_LABEL_KEYS: Record<
  ThreadStatus,
  ThreadStatusLabelKey
> = {
  [ThreadStatus.InProgress]: "threadStatusInProgress",
  [ThreadStatus.Error]: "threadStatusError",
  [ThreadStatus.Ready]: "threadStatusReady",
  [ThreadStatus.InputRequired]: "threadStatusInputRequired",
  [ThreadStatus.Completed]: "threadStatusCompleted",
  [ThreadStatus.Cancelled]: "threadStatusCancelled",
};

const THREAD_STATUSES = new Set(Object.values(ThreadStatus));

const isThreadStatus = (status: string): status is ThreadStatus =>
  THREAD_STATUSES.has(status as ThreadStatus);

export const mapThreadStatus = (status: string | null): ThreadStatus | null => {
  if (!status || !isThreadStatus(status)) return null;

  return status;
};

export type ThreadEntity = {
  chat_id: string;
  chat_name: string;
  creation_time: string;
  chat_type: "agent";
  agent_id: string;
  assistant_id?: string | null;
  is_favorite: boolean;
  last_message_at: string | null;
  last_read_at: string | null;
  status: ThreadStatus | null;
};
